import { GET_RATECARD } from "resources/actionTypes";

const intialState = {
  userRateCard: [],
  loading: false,
  error: null,
};

export function userRateCard(state = intialState, action) {
  switch (action.type) {
    case GET_RATECARD.GET_RATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_RATECARD.GET_RATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCard: action.userRateCard,
      }
    case GET_RATECARD.GET_RATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_RATECARD.GET_RATECARD_CLEARED:
      return {
        ...state,
        loading: false,
        userRateCard: [],
      }
    default:
      return state;
  }
}